<template>
  <q-field
    class="cursor-pointer"
    outlined
    @click="$refs.modalRef.show()"
  >
    <template #prepend>
      <q-icon
        name="img:common/icons/child-seat.svg"
        size="24px"
      />
    </template>
    <template #append>
      <div class="fs-16 text-black">
        {{ $t('button.edit') }}
      </div>
    </template>
    <template #control>
      <AdultsAndChildPax
        v-if="selectedChildSeatsLength"
        :child-seats-booster="transfer.child_seats_booster"
        :child-seats-convertible="transfer.child_seats_convertible"
        :child-seats-infant="transfer.child_seats_infant"
        with-chip
        without-pax
      />
      <div
        v-else
        class="text-grey-8"
      >
        {{ $t('transfer.child_seats') }}
      </div>
    </template>
    <Modal
      ref="modalRef"
      :title="$t('transfer.child_seats')"
      @show="$emit('show-modal')"
    >
      <q-list class="default-modal-padding">
        <q-item
          v-for="key in childSeats"
          :key="key"
          class="q-pa-none"
        >
          <q-item-section
            class="q-pr-8"
            side
          >
            <img :src="`common/icons/${key}.svg`">
          </q-item-section>
          <q-item-section>
            <q-item-label class="text-weight-medium">
              {{ $t(`transfer.${key}.title`) }}
            </q-item-label>
            <q-item-label class="fs-14">
              {{ $t(`transfer.${key}.description`) }}
            </q-item-label>
          </q-item-section>
          <NumberInputWithControls
            :model-value="transfer[key]"
            @update:modelValue="$emit('update:modelValue', key, $event)"
          />
        </q-item>
        <q-btn
          v-close-popup
          :label="$t('button.done')"
          class="full-width q-my-24"
          color="positive"
          padding="12px"
          unelevated
        />
      </q-list>
    </Modal>
  </q-field>
</template>

<script setup>
import { computed } from 'vue';

import NumberInputWithControls from '~components/NumberInputWithControls';
import AdultsAndChildPax from '~components/AdultsAndChildPax';
import Modal from '~components/Modal';

import childSeats from '~common/utils/childSeats';

const props = defineProps({
  transfer: {
    type: Object,
    required: true,
  },
});

defineEmits(['update:modelValue', 'show-modal']);

const selectedChildSeatsLength = computed(() => childSeats.filter((el) => props.transfer[el]).length);
</script>
